import axios, { AxiosInstance } from 'axios';
import { merge } from '../utility/common';
import {
  DEFAULT_HEADERS_BY_SERVICE,
  DEFAULT_TIMEOUTS,
  HTTP_METHODS
} from './api.constants';
import {
  axiosRejectedResponseInterceptor,
  axiosSuccessResponseInterceptor
} from './api.error.helpers';
import { setHeaders } from './api.headers';
import { ApiInstanceConfiguration } from './api.interfaces';
import { JSON_LONG_AS_STRING_PARAM } from './metadata.api.constants';
import {
  axiosMetadataRequestInterceptor,
  interceptRequestError
} from './metadata.api.helpers';

let metadataRequestInstance: AxiosInstance;

/** Initialize API for the metadata endpoint. */
export function init(config: ApiInstanceConfiguration) {
  metadataRequestInstance = axios.create({
    // @ts-ignore investigate if environmentUrls needs to be in ApiInstanceConfiguration
    baseURL: config.environmentUrls.metadata,
    headers: {
      common: setHeaders(DEFAULT_HEADERS_BY_SERVICE.metadata, config)
    },
    method: HTTP_METHODS.GET,
    timeout: DEFAULT_TIMEOUTS.METADATA
  });

  metadataRequestInstance.interceptors.request.use(
    axiosMetadataRequestInterceptor(config),
    interceptRequestError
  );
  metadataRequestInstance.interceptors.response.use(
    axiosSuccessResponseInterceptor,
    axiosRejectedResponseInterceptor
  );
}

export function retrieveMetadata<ResponseType>(
  { headers = {}, path }: { headers?: {}; path: string },
  params: {} = {}
): Promise<ResponseType> {
  // @ts-ignore
  const jsonLongAsString = params.jsonLongAsString
    ? `/${JSON_LONG_AS_STRING_PARAM}`
    : '';

  return metadataRequestInstance.request<any, ResponseType>({
    headers: merge(
      {},
      metadataRequestInstance.defaults.headers.common,
      headers
    ),
    url: `/${path}${jsonLongAsString}`
  });
}
